import React from 'react';
import { Box, Button, TextField, SelectChangeEvent } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';

interface AddServicesModalProps {
    serviceTypeOptions: { id: string; label: string }[];
    serviceType: string;
    setServiceType: (val: string) => void;
    serviceModelOptions: { id: string; label: string }[];
    serviceModel: string;
    handleServiceModelChange: (event: SelectChangeEvent<string>) => void;
    platformModelOptions: { id: string; label: string }[];
    platformModel: string;
    handlePlatformModelChange: (event: SelectChangeEvent<string>) => void;
    sellingPrice: string;
    setSellingPrice: (val: string) => void;
    handleSaveService: () => void;
}

const AddServicesModal: React.FC<AddServicesModalProps> = ({
    serviceTypeOptions,
    serviceType,
    setServiceType,
    serviceModelOptions,
    serviceModel,
    handleServiceModelChange,
    platformModelOptions,
    platformModel,
    handlePlatformModelChange,
    sellingPrice,
    setSellingPrice,
    handleSaveService
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 1, pb: 2 }}>
            <Box>
                <Dropdown 
                    options={serviceTypeOptions}
                    selectedValue={serviceType}
                    handleChange={(event: SelectChangeEvent<string>) => setServiceType(event.target.value)}
                    placeholder="Select Type"      
                    label="Service Type"        
                    height="40px"
                    width="220px"
                />
            </Box>
            
            {serviceType === 'device' && (
                <>
                    <Box>
                        <Dropdown 
                            options={serviceModelOptions}
                            selectedValue={serviceModel}
                            handleChange={handleServiceModelChange}
                            placeholder='Select Model'
                            label='Select Model'
                            height="40px"
                            width="220px"
                        />
                    </Box>
                    <Box>
                        <Dropdown 
                            options={platformModelOptions}
                            selectedValue={platformModel}
                            handleChange={handlePlatformModelChange}
                            placeholder='Select Anytrakk Model'
                            label='Anytrakk Model Name'
                            height="40px"
                            width="220px"
                        />
                    </Box>
                </>
            )}
            
            {serviceType === 'subscription' && (
                <>
                    <Box>
                        <Dropdown 
                            options={serviceModelOptions}
                            selectedValue={serviceModel}
                            handleChange={(e: SelectChangeEvent<string>) => {
                                handleServiceModelChange(e);
                            }}
                            placeholder='Type of Subscription'
                            label='Type of Subscription'
                            height="40px"
                            width="220px"
                        />
                    </Box>
                    <Box>
                        <Dropdown 
                            options={platformModelOptions}
                            selectedValue={platformModel}
                            handleChange={handlePlatformModelChange}
                            placeholder='Select Anytrakk Model'
                            label='Anytrakk Model Name'
                            height="40px"
                            width="220px"
                        />
                    </Box>
                </>
            )}
            
            <TextField 
                label="Selling Price" 
                size="small" 
                type="number" 
                value={sellingPrice}
                onChange={(e) => setSellingPrice(e.target.value)}
                sx={{ width: '220px' }} 
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained" className="custom-button" onClick={handleSaveService}>
                    Save
                </Button>
            </Box>
        </Box>
    );
};

export default AddServicesModal;